<template>
    <div>
        <div v-if="activePayment && activePayment.payment_logs" class="pa-5">
            <div v-for="item in activePayment.payment_logs" :key="item.id">
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Log ID" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.id ? item.id : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Payment ID" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.payment_id ? item.payment_id : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Action" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.action ? item.action : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Message" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.message ? item.message : "-" }}
                    </v-col>
                </v-row>
                <v-row v-if="item.data">
                    <v-col class="col-item row-title" cols="3">{{ "Data" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        <span v-if="isJSON(item.data)">
                            <vue-json-pretty :data="JSON.parse(item.data)" :deep="0" collapsedOnClickBrackets
                        /></span>
                        <span v-else>{{ item.data }}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "User agent" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.user_agent ? item.user_agent : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Event at" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.event_at ? tz(item.event_at) : "-" }}
                    </v-col>
                </v-row>
                <v-row v-if="item.ip">
                    <v-col class="col-item row-title" cols="3">{{ "IP" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.ip ? item.ip : "-" }}
                    </v-col>
                </v-row>
                <v-divider class="mb-6 mt-6" />
            </div>
        </div>
        <div v-else class="pa-5">{{ "No data" | t }}</div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
    name: "payment-logs-tab",
    components: { VueJsonPretty },
    computed: {
        ...mapState("paymentHistory", ["activePayment"])
    },
    methods: {
        isJSON(value) {
            try {
                JSON.parse(value);
                return true;
            } catch (e) {
                return false;
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
